import { MealType } from "model/food/types"
import {
  IAIScanForSchedulePayload,
  IAIScanNutritionFactForSchedulePayload,
  IAIScanPackedForSchedulePayload,
  ICreateSchedulePayload,
  IEdamaForSchedulePayload,
  IMyFoodForSchedulePayload,
  IOpenFoodFactForSchedulePayload,
  IScheduleConfigPayload,
} from "model/food/types/schedulePayloads.types"
import { IEdamaMeal } from "model/food/types/edama.types"
import { getMealNutritionPayload } from "./getBaseMealPayloadFromFood"
import { getImagePayload } from "./getImagePayload"
import { IMyMeal } from "model/food/types/myfood.types"
import { LogMealType } from "model/food/types/base.types"
import {
  IAIScanMeal,
  IAIScanNutritionFactMeal,
  IAIScanPackageMeal,
} from "model/food/types/AIScan.types"
import { IOpenFoodFactMeal } from "model/food/types/openFoodFact.types"

const getSchedulePayloadFormEdamaMeal = ({
  meal,
  mealType,
  configPayload,
}: {
  meal: IEdamaMeal
  mealType?: LogMealType
  configPayload: IScheduleConfigPayload
}) => {
  const payload: IEdamaForSchedulePayload = {
    ...getMealNutritionPayload(meal),
    ...getImagePayload(meal),
    ...configPayload,
    mealName: meal.name,
    portion: meal.portion,
    unit: meal.unit,
    foodId: meal.foodId!,
    units: meal.units,
    source: "EDAMAM",
    brand: meal.brand,
    mealType,
  }

  return payload
}

const getSchedulePayloadFormMyMeal = ({
  meal,
  mealType,
  configPayload,
}: {
  meal: IMyMeal
  mealType?: LogMealType
  configPayload: IScheduleConfigPayload
}): IMyFoodForSchedulePayload => {
  const payload: IMyFoodForSchedulePayload = {
    ...getMealNutritionPayload(meal),
    ...getImagePayload(meal),
    ...configPayload,
    mealName: meal.name,
    portion: meal.portion,
    unit: meal.unit,
    foodId: meal.foodId!,
    source: "MY_FOOD",
    ingredients: meal.ingredients,
    mealType,
  }
  return payload
}

const getSchedulePayloadFormAIScanMeal = ({
  meal,
  mealType,
  configPayload,
}: {
  meal: IAIScanMeal
  mealType?: LogMealType
  configPayload: IScheduleConfigPayload
}): IAIScanForSchedulePayload => {
  const payload: IAIScanForSchedulePayload = {
    ...getMealNutritionPayload(meal),
    ...getImagePayload(meal),
    ...configPayload,
    mealName: meal.name,
    portion: meal.portion,
    unit: meal.unit,
    foodId: meal.foodId!,
    source: "AI_SCAN_MEAL",
    mealType,
    ingredients: meal.ingredients
  }
  return payload
}

const getSchedulePayloadFromOpenFoodFactMeal = ({
  meal,
  mealType,
  configPayload,
}: {
  meal: IOpenFoodFactMeal
  mealType?: LogMealType
  configPayload: IScheduleConfigPayload
}): IOpenFoodFactForSchedulePayload => {
  const payload: IOpenFoodFactForSchedulePayload = {
    ...getMealNutritionPayload(meal),
    ...getImagePayload(meal),
    ...configPayload,
    mealName: meal.name,
    portion: meal.portion,
    unit: meal.unit,
    foodId: meal.foodId!,
    source: "OPEN_FOOD_FACTS",
    brand: meal.brand,
    mealType,
  }
  return payload
}

const getSchedulePayloadFormAIScanPackageMeal = ({
  meal,
  mealType,
  configPayload,
}: {
  meal: IAIScanPackageMeal
  mealType?: LogMealType
  configPayload: IScheduleConfigPayload
}) => {
  const payload: IAIScanPackedForSchedulePayload = {
    ...getMealNutritionPayload(meal),
    ...getImagePayload(meal),
    ...configPayload,
    mealName: meal.name,
    portion: meal.portion,
    unit: meal.unit,
    foodId: meal.foodId!,
    source: "AI_SCAN_PACKAGE",
    mealType,
  }

  return payload
}

const getSchedulePayloadFormAIScanNutritionFactMeal = ({
  meal,
  mealType,
  configPayload,
}: {
  meal: IAIScanNutritionFactMeal
  mealType?: LogMealType
  configPayload: IScheduleConfigPayload
}) => {
  const payload: IAIScanNutritionFactForSchedulePayload = {
    ...getMealNutritionPayload(meal),
    ...getImagePayload(meal),
    ...configPayload,
    mealName: meal.name,
    portion: meal.portion,
    unit: meal.unit,
    foodId: meal.foodId!,
    source: "AI_SCAN_NUTRITION_FACTS",
    mealType,
  }

  return payload
}

const getSchedulePayloadFromMeal = ({
  meal,
  configPayload,
  mealType,
}: {
  meal: MealType
  configPayload: IScheduleConfigPayload
  mealType?: LogMealType
}): ICreateSchedulePayload | undefined => {
  switch (meal.source) {
    case "EDAMAM":
      return getSchedulePayloadFormEdamaMeal({
        meal,
        mealType,
        configPayload,
      })

    case "MY_FOOD":
      return getSchedulePayloadFormMyMeal({
        meal,
        mealType,
        configPayload,
      })

    case "AI_SCAN_MEAL":
      return getSchedulePayloadFormAIScanMeal({
        meal,
        mealType,
        configPayload,
      })

    case "AI_SCAN_PACKAGE":
      return getSchedulePayloadFormAIScanPackageMeal({
        meal,
        mealType,
        configPayload,
      })

    case "AI_SCAN_NUTRITION_FACTS":
      return getSchedulePayloadFormAIScanNutritionFactMeal({
        meal,
        mealType,
        configPayload,
      })

    case "OPEN_FOOD_FACTS":
      return getSchedulePayloadFromOpenFoodFactMeal({
        meal,
        mealType,
        configPayload,
      })

    default:
      break
  }
}

export default getSchedulePayloadFromMeal
